import { useState } from "react";
import { useNavigate } from "react-router-dom";

const projectTypes = [
  "Mobile Game",
  "Web Game",
  "Desktop Game",
  "Gamified App",
  "Interactive Experience",
  "Prototype / MVP",
  "Other",
];

export const ContactForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    projectType: "",
    message: "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log("Form data submitted:", formData);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full max-w-lg bg-gray-900/90 backdrop-blur-sm border border-gray-700 p-8 rounded-xl shadow-xl"
    >
      <h2 className="text-2xl font-bold text-center text-white mb-2">
        Start a Project
      </h2>
      <p className="text-gray-400 text-center mb-6 text-sm">
        Tell us about your idea and we'll get back to you.
      </p>

      <label htmlFor="name" className="block text-gray-300 mb-1 text-sm font-medium">
        Name
      </label>
      <input
        type="text"
        id="name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        placeholder="Your Name"
        required
        className="w-full px-4 py-2 mb-4 bg-gray-800 border border-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-green-400 placeholder-gray-500"
      />

      <label htmlFor="company" className="block text-gray-300 mb-1 text-sm font-medium">
        Company <span className="text-gray-500">(optional)</span>
      </label>
      <input
        type="text"
        id="company"
        name="company"
        value={formData.company}
        onChange={handleChange}
        placeholder="Your Company"
        className="w-full px-4 py-2 mb-4 bg-gray-800 border border-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-green-400 placeholder-gray-500"
      />

      <label htmlFor="email" className="block text-gray-300 mb-1 text-sm font-medium">
        Email
      </label>
      <input
        type="email"
        id="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="Your Email"
        required
        className="w-full px-4 py-2 mb-4 bg-gray-800 border border-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-green-400 placeholder-gray-500"
      />

      <label htmlFor="projectType" className="block text-gray-300 mb-1 text-sm font-medium">
        Project Type
      </label>
      <select
        id="projectType"
        name="projectType"
        value={formData.projectType}
        onChange={handleChange}
        required
        className="w-full px-4 py-2 mb-4 bg-gray-800 border border-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-green-400 appearance-none"
      >
        <option value="" disabled>
          Select a project type
        </option>
        {projectTypes.map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </select>

      <label htmlFor="message" className="block text-gray-300 mb-1 text-sm font-medium">
        Tell Us About Your Project
      </label>
      <textarea
        id="message"
        name="message"
        value={formData.message}
        onChange={handleChange}
        placeholder="Describe your idea, goals, timeline..."
        rows={5}
        required
        className="w-full px-4 py-2 mb-6 bg-gray-800 border border-gray-600 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-green-400 placeholder-gray-500"
      ></textarea>

      <button
        type="submit"
        className="w-full bg-green-indie text-black font-bold py-3 rounded-lg hover:bg-green-600 transition-all hover:scale-[1.02] active:scale-[0.98]"
        onClick={() => navigate("/")}
      >
        Send Message
      </button>
    </form>
  );
};
